function Menu() {
    return (
        <nav>
            <ul>
                <li>Game</li>
                <li>Hint</li>
                <li>Undo</li>
            </ul>
        </nav>
    );
}

export default Menu;